/**
 * TrialCallout — sky-tinted card explaining the 14-day trial.
 * Used inline on S03 above the "Create workspace" submit button.
 */
import { Sparkles } from "lucide-react";

export function TrialCallout() {
  return (
    <div className="flex items-start gap-2.5 p-3 rounded bg-sky-50 ring-1 ring-sky-100/60">
      <span
        aria-hidden
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-paper text-sky-600 mt-px ring-1 ring-line"
      >
        <Sparkles size={11} />
      </span>
      <div className="flex flex-col gap-0.5">
        <strong className="text-xs leading-[16px] font-semibold text-ink">
          14-day free trial
        </strong>
        <span className="text-xs leading-[17px] text-ink-2">
          Create the workspace now, explore the real product, and activate billing before the trial
          ends to keep writing data.
        </span>
      </div>
    </div>
  );
}
